<template>
  <div>
    <div class="image-with-zoom">
      <div class="document-image-container">
        <img
          :src="imageSrc"
          :class="['document-thumbnail', imageClass]"
          @click="handleImageClick"
          :alt="imageAlt"
          :loading="loading ? 'lazy' : 'eager'"
        />
        <!-- <button
          class="btn btn-sm btn-secondary mt-1 zoom-button"
          @click="handleImageClick"
        >
          <i class="bi bi-zoom-in"></i> 拡大表示
        </button> -->
      </div>
    </div>

    <ImageModal
      :show="showModal"
      :image-src="imageSrc"
      :title="modalTitle"
      @close="handleModalClose"
    />
  </div>
</template>

<script>
import ImageModal from './ImageModal.vue'

export default {
  name: 'ImageWithZoom',
  components: {
    ImageModal
  },
  props: {
    imageSrc: {
      type: [String, null],
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    imageAlt: {
      type: String,
      default: '画像'
    },
    modalTitle: {
      type: String,
      default: '画像の詳細表示'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    handleImageClick() {
      this.showModal = true
    },
    handleModalClose() {
      this.showModal = false
    },
    handleImageError(e) {
      this.$emit('error', e)
    }
  }
}
</script>

<style scoped>
.image-with-zoom {
  position: relative;
  display: inline-block;
  width: 100%;
}

.document-image-container {
  position: relative;
  margin-bottom: 1rem;
}

.document-thumbnail {
  max-height: 200px;
  width: auto;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: filter 0.2s;
}

.zoom-button {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: rgba(108, 117, 125, 0.9);
  border: none;
  color: white;
  padding: 4px 8px;
  font-size: 0.875rem;
  border-radius: 4px;
  transition: background-color 0.2s;
  z-index: 1;
}

.zoom-button:hover {
  background: rgba(73, 80, 87, 0.9);
}

.image-with-zoom:hover .document-thumbnail {
  filter: brightness(0.9);
}
</style>
